import React, { createContext, useMemo, useEffect } from 'react';
import { useAsyncSafeState } from 'ui-components/hooks/async-safe';
import PropTypes from 'prop-types';
import { getInvoices } from '../api/subscription';
import { createLookupHash } from '../../../services/hash-service';

const InvoicesContext = createContext({});

const InvoicesContextProvider = ({ children }) => {
  const [invoiceIds, setInvoiceIds] = useAsyncSafeState([]);
  const [invoices, setInvoices] = useAsyncSafeState({});
  const [isLoading, setIsLoading] = useAsyncSafeState(true);
  const [hasError, setHasError] = useAsyncSafeState(false);

  useEffect(() => {
    getInvoices()
      .then((response) => {
        const ids = response?.data.map((inv) => inv.invoiceNumber);
        setInvoiceIds(ids);
        setInvoices(createLookupHash(response?.data, 'invoiceNumber'));
        setIsLoading(false);
      })
      .catch(() => {
        setIsLoading(false);
        setHasError(true);
      });
  }, [setHasError, setInvoiceIds, setInvoices, setIsLoading]);

  const value = useMemo(
    () => ({
      invoiceIds,
      invoices,
      isLoading,
      hasError,
    }),
    [invoiceIds, invoices, isLoading, hasError],
  );

  return <InvoicesContext.Provider value={value}>{children}</InvoicesContext.Provider>;
};

InvoicesContextProvider.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
};

export { InvoicesContext };

export default InvoicesContextProvider;
